var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDevices(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "hinava_random_uuid_203134470885625993891025397689406329592",
    d: "M15.524 0c1.733 0 3.143 1.314 3.143 2.928v18.144c0 1.614-1.41 2.928-3.143 2.928H3.143C1.41 24 0 22.686 0 21.072V2.928C0 1.314 1.41 0 3.143 0zm0 1.328H3.143c-.947 0-1.717.718-1.717 1.6v18.144c0 .882.77 1.6 1.717 1.6h12.381c.947 0 1.717-.718 1.717-1.6V2.928c0-.882-.77-1.6-1.717-1.6zm-6.19 10.81c2.646 0 4.799 2.006 4.799 4.472 0 2.466-2.153 4.472-4.8 4.472-2.646 0-4.8-2.006-4.8-4.472 0-2.466 2.154-4.473 4.8-4.473zm0 1.328c-1.861 0-3.375 1.41-3.375 3.144 0 1.733 1.514 3.144 3.374 3.144s3.374-1.41 3.374-3.144c0-1.734-1.513-3.144-3.374-3.144zm-.015.96c1.293 0 2.344.98 2.344 2.184 0 1.204-1.052 2.184-2.344 2.184-1.292 0-2.344-.98-2.344-2.184 0-1.204 1.052-2.184 2.344-2.184zm0 1.328c-.506 0-.918.384-.918.856s.412.855.918.855.918-.383.918-.855-.412-.856-.918-.856zm5.748-13.629c.667 0 1.21.506 1.21 1.128V9.71c0 .622-.543 1.127-1.21 1.127H3.6c-.667 0-1.21-.505-1.21-1.127V3.253c0-.622.543-1.128 1.21-1.128zm-.216 1.329H3.816v6.055H14.85V3.454z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.667 4)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "hinava_random_uuid_109870223160400952289106018797506193058",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hinava_random_uuid_203134470885625993891025397689406329592"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    fillRule: "nonzero",
    xlinkHref: "#hinava_random_uuid_203134470885625993891025397689406329592"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#23D4FF",
    mask: "url(#hinava_random_uuid_109870223160400952289106018797506193058)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    transform: "translate(-6.667 -4)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevices);
export default __webpack_public_path__ + "static/media/devices.a88376511120670b2d17b2f4ff2095ea.svg";
export { ForwardRef as ReactComponent };